import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { LayoutProps } from '../types';

import * as S from './styled';

const CompanionModeLayout = ({ children, titleKey }: LayoutProps) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = t(titleKey);
    }, [t, titleKey]);

    return (
        <S.BodyContainer isBlack>
            <S.MainContainer>{children}</S.MainContainer>
        </S.BodyContainer>
    );
};

export default CompanionModeLayout;
